<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-card class="pa-1">
        <v-card-text class="pa-0">
            <table class="mb-2">
                <tr>
                    <td style="width:100%"><h2>{{sensors[0].body.name}}<span v-if="sensors.length > 1">他</span></h2></td>
                    <td v-if="canSetting">
                        <v-btn icon color="primary" @click="onClickSensorSetting"><v-icon>mdi-cog-outline</v-icon></v-btn>
                    </td>
                    <td>
                        <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn 
                                    class="mt-2" 
                                    v-bind="attrs"
                                    v-on="on"
                                    icon 
                                    color="primary">
                                    <v-icon>mdi-download</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item 
                                    v-for="menuItem in outputMenuItems" :key="menuItem.type"
                                    @click="onSelectedOutputMenu(menuItem)">
                                    <v-list-item-title>{{menuItem.text}}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </td>
                </tr>
                <tr>
                    <td colspan="3">
                        <v-divider />
                    </td>
                </tr>
            </table>
            <!-- {{chartControlValues.height}} -->
            <!-- <div :style="'position:relative; height:'+chartControlValues.height+'px'"> -->
            <SensorChart 
                v-if="!chartRefresh" 
                ref="chart" 
                :sensors="sensors" 
                :condition="condition" 
                :selectedSensor="selectedSensor" 
                :alarmsOnChart="alarmsOnChart" 
                :controlValues="chartControlValues" 
                :height="chartControlValues.height"
                :guideLine="chartGuideLine"
                @click="onClickChart" />
            <!-- </div> -->
            <ChartValues
                :guideLine="chartGuideLine"
                />
            <SensorChartController :controlValues="chartControlValues" />
            <table style="width:100%">
                <tr>
                    <td class="pt-2">
                        <v-simple-table dense v-if="!$vuetify.breakpoint.xs">
                            <thead>
                                <tr>
                                    <th class="text-center">軸1</th>
                                    <th class="text-center">軸2</th>
                                    <th class="text-left" style="width:100%">センサー</th>
                                    <th class="text-center">最高</th>
                                    <th class="text-center">最低</th>
                                    <th class="text-center">平均</th>
                                    <th class="text-center">測定数</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="sensor in sensors" :key="sensor.body.sensorKey" @click="onClickSensor(sensor)" :class="selectedSensor != null && sensor.body.sensorKey == selectedSensor.body.sensorKey ? 'teal lighten-5' : ''">
                                    <td>
                                        <v-btn icon @click.stop="onClickSensorYAxis(sensor, 1)">
                                            <v-icon v-if="sensor.yAxis == 1" small>mdi-radiobox-marked</v-icon>
                                            <v-icon v-else small>mdi-radiobox-blank</v-icon>
                                        </v-btn>
                                    </td>
                                    <td>
                                        <v-btn icon @click.stop="onClickSensorYAxis(sensor, 2)">
                                            <v-icon v-if="sensor.yAxis == 2" small>mdi-radiobox-marked</v-icon>
                                            <v-icon v-else small>mdi-radiobox-blank</v-icon>
                                        </v-btn>
                                    </td>
                                    <template v-if="sensor.measureInformation != null">
                                        <td>{{sensor.body.name}}</td>
                                        <td>{{sensor.measureInformation.max.toFixed(1)}}{{sensor.body.unit}}</td>
                                        <td>{{sensor.measureInformation.min.toFixed(1)}}{{sensor.body.unit}}</td>
                                        <td>{{sensor.measureInformation.average.toFixed(1)}}{{sensor.body.unit}}</td>
                                        <td>{{sensor.measureInformation.num}}</td>
                                    </template>
                                    <template v-else>
                                        <td>{{sensor.body.name}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </template>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <v-simple-table dense v-else>
                            <tbody>
                                <tr v-for="sensor in sensors" :key="sensor.body.sensorKey" @click="onClickSensor(sensor)">
                                    <v-card outlined class="pa-1 ma-1">
                                        <table style="width:100%" :class="selectedSensor != null && sensor.body.sensorKey == selectedSensor.body.sensorKey ? 'teal lighten-5' : ''">
                                            <tr>
                                                <td colspan="2" class="text-subtitle-1">
                                                    {{sensor.body.name}}
                                                </td>
                                                <td>
                                                    <v-btn icon @click.stop="onClickSensorYAxis(sensor, 1)">
                                                        <v-icon v-if="sensor.yAxis == 1" small>mdi-radiobox-marked</v-icon>
                                                        <v-icon v-else small>mdi-radiobox-blank</v-icon>
                                                        軸1
                                                    </v-btn>
                                                </td>
                                                <td>
                                                    <v-btn icon @click.stop="onClickSensorYAxis(sensor, 2)">
                                                        <v-icon v-if="sensor.yAxis == 2" small>mdi-radiobox-marked</v-icon>
                                                        <v-icon v-else small>mdi-radiobox-blank</v-icon>
                                                        軸2
                                                    </v-btn>
                                                </td>
                                            </tr>
                                            <tr class="text-caption">
                                                <template v-if="sensor.measureInformation != null">
                                                    <td class="text-center">
                                                        <v-sheet outlined rounded >
                                                            最高<br/>
                                                            {{sensor.measureInformation.max.toFixed(1)}}{{sensor.body.unit}}
                                                        </v-sheet>
                                                    </td>
                                                    <td class="text-center">
                                                        <v-sheet outlined rounded >
                                                            最低<br/>
                                                            {{sensor.measureInformation.min.toFixed(1)}}{{sensor.body.unit}}
                                                        </v-sheet>
                                                    </td>
                                                    <td class="text-center">
                                                        <v-sheet outlined rounded >
                                                            平均<br/>
                                                            {{sensor.measureInformation.average.toFixed(1)}}{{sensor.body.unit}}
                                                        </v-sheet>
                                                    </td>
                                                    <td class="text-center">
                                                        <v-sheet outlined rounded >
                                                            測定数<br/>
                                                            {{sensor.measureInformation.num}}
                                                        </v-sheet>
                                                    </td>
                                                </template>
                                                <template v-else>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </template>
                                            </tr>
                                        </table>
                                    </v-card>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </td>
                </tr>
                <tr>
                    <td class="pt-2">
                        <v-divider class="mt-2 mb-2" />
                        <SensorAlarmHistory :sensors="sensors" :alarmsOnChart="alarmsOnChart" />
                    </td>
                </tr>
            </table>
            <!-- <v-divider />
            <v-toolbar flat dense>
                <v-btn class="mt-2" icon color="primary" @click="onClickSensorSetting"><v-icon>mdi-download</v-icon></v-btn>
            </v-toolbar> -->
        </v-card-text>
        <Maintenance ref="sensorMaintenance" @onUpdatedSensor="onUpdatedSensor" />
    </v-card>

</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }

    import db from '@/firebase/firestore.js'
    import SensorChart from '@/components/box/ChartSensor';
    import SensorChartController from '@/components/box/ChartController';
    import ChartValues from '@/components/box/ChartSelectPositionValues';
    import SensorAlarmHistory from '@/components/box/SensorAlarmHistory';
    import Maintenance from '@/components/box/MaintenanceSensor';
    import BoxRegister from '@/components/box/RegisterBoxMaster';
    
    export default {
        components: {
            SensorChart,
            SensorChartController,
            ChartValues,
            SensorAlarmHistory,
            Maintenance
        },
        props: {
            /**
             * 表示対象のセンサー(複数)
             */
            sensors: null,
            /**
             * 表示条件
             */
            condition: {},
        },
        data: function () {
            return {
                /** 選択されているセンサー */
                selectedSensor: null,
                /** チャートに重ねる警報 */
                alarmsOnChart: [],
                /** 出力メニュー */
                outputMenuItems: [
                    {type: "values", text: "測定値のみ"},
                    {type: "alarms", text: "異常/警報のみ"},
                    {type: "both", text: "測定値と警報"},
                ],
                /** センサー毎の日毎の警報レコードをキャッシュする連想配列 */
                sensorAlarmCache: {},
                /** チャートのオプション項目 */
                chartControlValues: {
                    /** 表示条件への参照 */
                    condition: this.condition,
                    /** Y軸を自動設定するか否か */
                    enabledYAxisFitValue: false,
                    /** チャートの高さ */
                    height: 600,
                    /** ズーム(0～1) */
                    zoom: 0,
                    /** 現在位置(パン) */
                    position: 0,
                    /** 最小表示範囲 */
                    minRange: function () {
                        switch (this.condition.range) {
                            case "month":
                                // 表示範囲="月"
                                return 1000 * 60 * 60 * 24   // 1日
                            case "day":
                            case "day_range":
                                // 表示範囲="日" or "日範囲"
                                return 1000 * 60 * 60   // 1時間
                        }
                    },
                    /** 最大表示範囲 */
                    maxRange: function () {
                        const conditionViewRange = this.condition.viewRange()
                        return conditionViewRange.toTime - conditionViewRange.fromTime
                    },
                    /** 表示範囲(チャートに何msの範囲を表示するか) */
                    viewRange: function () {
                        return this.maxRange() * (1-this.zoom) + (this.minRange() * this.zoom)
                    },
                    /** 表示開始日時 */
                    from: function () {
                        // console.log("chartControlValues", "from", this)
                        const conditionViewRange = this.condition.viewRange()
                        const length = conditionViewRange.toTime - this.viewRange() - conditionViewRange.fromTime // 移動可能量
                        const fromTime = conditionViewRange.fromTime + (this.position * length)
                        return fromTime
                    },
                    /** 表示終了日時 */
                    to: function () {
                        return this.from() + this.viewRange()
                    },
                    /** リセット */
                    reset: function () {
                        this.zoom = 0
                        this.position = 0
                    }
                },
                /** チャートに表示するガイドライン */
                chartGuideLine: {
                    isVisible: false,
                    x: null,
                    chart: null
                },
                /** チャートの高さを変更した時に、一旦チャートを破棄する為のフラグ(ONさせて破棄し、すぐにOFFにして再度インスタンスを作成する - 他に手段があればそれに変更する事！) */
                chartRefresh: false
            }
        },
        watch: {
            /**
             * 変更監視:チャートの高さ
             */
            "chartControlValues.height": function (value, old) {
                const self = this
                this.chartRefresh = true
                setTimeout(()=>self.chartRefresh = false, 100)
            },
            // "chartControlValues.zoom": function (value, old) {
            //     console.log("view range", this.chartControlValues.zoom, this.chartControlValues.position, new Date(this.chartControlValues.from()).toFormatString("yyyy-MM-dd HH:mm:ss"), new Date(this.chartControlValues.to()).toFormatString("yyyy-MM-dd HH:mm:ss"))
            // },
            // "chartControlValues.position": function (value, old) {
            //     console.log("view range", this.chartControlValues.zoom, this.chartControlValues.position, new Date(this.chartControlValues.from()).toFormatString("yyyy-MM-dd HH:mm:ss"), new Date(this.chartControlValues.to()).toFormatString("yyyy-MM-dd HH:mm:ss"))
            // }
            condition: {
                handler: function (value, old) {
                    this.chartControlValues.reset()
                    this.chartGuideLine.isVisible = false
                },
                deep: true
            }
                    // range: "month",
                    // year: 2020,
                    // month: 8,
                    // date: "",
                    // dateFrom: "",
                    // dateTo: "",

        },
        computed: {
            /**
             * ユーザーUID(グループユーザーの圃場参照時は、そのユーザーのUID)
             */
            userUID: function () {
                return this.$store.getters["userUID"]
            },
            /**
             * ログインユーザーのUID
             */
            loggedInUserUID: function () {
                return this.$store.getters["loggedInUserUID"]
            },
            /**
             * ログインユーザーデータ
             */
            loggedInUserData: function () {
                return this.$store.getters["loggedInUserData"]
            },
            /** 共有モード */
            shareMode: function () {
                return this.$store.getters["shareMode"]
            },
            /** 共有モードの全種類 */
            shareModeTypes: function () {
                return this.$store.getters["shareModeTypes"]
            },
            /** グループユーザーの圃場管理を参照中は True */
            isShareMode: function () {
                if (this.shareMode == this.shareModeTypes.groupUserWork) {
                    return true
                }
                return false
            },
            /**
             * センサー設定を行えるか否か
             */
            canSetting: function () {
                console.log("canSetting", this.sensors)
                if (this.sensors.length == 1 &&  !this.isShareMode && (this.sensors.findIndex((v)=>v.boxMaster.userUID != this.loggedInUserUID) < 0 || this.loggedInUserData.isSystemManager)) {
                    return true
                }
                return false
            }
        },
        methods: {
            /**
             * チャートクリック時
             */
            onClickChart: function (x) {
                console.log("onClickChart", x)
                this.chartGuideLine.chart = this.$refs.chart
                this.chartGuideLine.x = x
                this.chartGuideLine.isVisible = true
            },
            /**
             * センサー一覧のセンサー押下時
             */
            onClickSensor: function (sensor) {
                console.log("onClickSensor", sensor)
                if (this.selectedSensor != null && this.selectedSensor.body.sensorKey == sensor.body.sensorKey) {
                    this.selectedSensor = null
                } else {
                    this.selectedSensor = sensor
                }
                console.log(this.selectedSensor)
            },
            /**
             * センサー設定ボタン押下時
             */
            onClickSensorSetting: function () {
                this.$refs.sensorMaintenance.show(this.sensors[0].body)
            },
            /**
             * センサーの表示/非表示ボタン押下時
             */
            onClickSensorViewState: function (sensor) {
                sensor.isVisible = !sensor.isVisible
                this.$refs.chart.refresh()
            },
            /**
             * センサーの軸ボタン押下時
             */
            onClickSensorYAxis: function (sensor, yAxis) {
                sensor.yAxis = yAxis
                this.$refs.chart.refresh()
            },
            /**
             * 出力メニュー項目選択時
             */
            onSelectedOutputMenu: function (item) {
                console.log(item)
                var text = ""
                switch (item.type) {
                    case "values":
                        text = this.createOutputText_values()
                        break;
                    case "alarms":
                        text = this.createOutputText_alarms()
                        break;
                    case "both":
                        text = this.createOutputText_values_alarms()
                        break;
                }
                
                const blob = new Blob([text], {type: "text/csv"})
                const link = document.createElement("a")
                link.href = window.URL.createObjectURL(blob)
                link.download = "values.csv"
                link.click()
            },
            /**
             * センサーの設定画面で設定内容が更新された時
             */
            onUpdatedSensor: function (updateInfo) {
                console.log("onUpdatedSensor", updateInfo, this.sensors)
                const self = this
                this.$refs.chart.refresh()

                const updatedSensor = this.sensors.find((v)=>v.body.sensorKey == updateInfo.sensor.sensorKey)
                const register = new BoxRegister.Register()
                register.Regist(this, updatedSensor.boxMaster)

                console.log("box updated!!!!!")
            },
            /**
             * ファイルに出力するテキストデータを作成(測定値のみ)
             */
            createOutputText_values: function () {
                var text = ""
                text = "\ufeff" + "センサー,測定日時,測定値\n"

                const chartData = this.$refs.chart.getChartData()
                const datasets = chartData.data.datasets.filter((v)=>v.additionalData.type == "measure_dataset")
                for (var dataset of datasets) {
                    for (var data of dataset.data) {                        
                        text += (data.additionalData.sensor.body.name + ",")
                        text += (data.x + ",")
                        text += data.y
                        text += "\n"
                    }
                }

                return text
            },
            /**
             * ファイルに出力するテキストデータを作成(異常/警報のみ)
             */
            createOutputText_alarms: function () {
                var text = ""
                text = "\ufeff" + "センサー,異常日時,内容\n"

                console.log(this.sensors)

                for (var sensor of this.sensors) {
                    for (var alarmHistory of sensor.alarmHistories) {
                        const date = new Date(alarmHistory.time)
                        text += (sensor.body.name + ",")
                        text += (date.toFormatString("yyyy-MM-dd HH:mm") + ",")
                        switch (alarmHistory.alarmType) {
                            case 1:
                                text += ("測定値が上限を超えました。("+alarmHistory.alarmData.value+")")
                                break;
                            case 2:
                                text += ("測定値が下限を下回りました。("+alarmHistory.alarmData.value+")")
                                break;
                            case 3:
                                text += ("センサー異常("+alarmHistory.alarmData.error+")")
                                break;
                            default:
                                text += ("unknown alarm("+alarmHistory.alarmType+")")
                        }
                        text += "\n"
                    }
                }

                return text
            },
            /**
             * ファイルに出力するテキストデータを作成(測定値と異常/警報両方)
             */
            createOutputText_values_alarms: function () {

            }
        }
    }
</script>
